module.exports = __webpack_public_path__ + "static/media/tomobrien.ab052bd6.png";